import { render, staticRenderFns } from "./CreateEditDeliveryZone.vue?vue&type=template&id=069ce6d1"
import script from "./CreateEditDeliveryZone.vue?vue&type=script&lang=js"
export * from "./CreateEditDeliveryZone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports